/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import Add from "./Add";
import Table5 from "./Table5";
import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";
import { header } from "../../../../components/api/Header";
import { getEnv } from "../../../../lib/env";
import {
  getDateColumnsInRange,
  getDefaultRange,
  getMonthRange,
  getMonthsInRange,
  isValidRange,
  normalizeRangeRows,
} from "../ravotxoji/rangeHelpers";

const createEmptyReka02Row = (column) => ({
  sana: column.date,
  reka: {},
  tashlama: {},
});

const normalizeReka02MonthRows = (month, rows) => {
  const monthRange = getMonthRange(month);

  if (!monthRange) {
    return rows || [];
  }

  const columns = getDateColumnsInRange(monthRange.from, monthRange.to);

  return normalizeRangeRows(
    { [month]: rows || [] },
    columns,
    createEmptyReka02Row
  );
};

function Reka02(props) {
  const defaultRange = getDefaultRange();
  const [toggle, setToggle] = useState(2);
  const [data, setData] = useState([]);
  const [rangeData, setRangeData] = useState([]);
  const [range, setRange] = useState(defaultRange);
  const [localRange, setLocalRange] = useState(defaultRange);
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(false);

  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);
  const tabs = [
    { title: "Oraliq", id: 2, type: "text" },
    { title: "Oylik", id: 1, type: "text" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/reka02/index?month=" +
            month,
          header()
        );
        setData(normalizeReka02MonthRows(month, res.data));
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [month]);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  useEffect(() => {
    if (toggle !== 2) {
      return;
    }

    if (!isValidRange(range)) {
      setRangeData([]);
      return;
    }

    const fetchRangeData = async () => {
      setLoading(true);
      const columns = getDateColumnsInRange(range.from, range.to);
      const months = getMonthsInRange(range.from, range.to);

      try {
        const responses = await Promise.all(
          months.map((rangeMonth) =>
            axios.get(
              getEnv('REACT_APP_BASE_URL') +
                "/v1/region/reka02/index?month=" +
                rangeMonth,
              header()
            )
          )
        );
        const monthlyData = {};
        months.forEach((rangeMonth, index) => {
          monthlyData[rangeMonth] = responses[index]?.data || [];
        });
        setRangeData(
          normalizeRangeRows(monthlyData, columns, createEmptyReka02Row)
        );
      } catch (e) {
        console.log("Xato", e);
        alert("Server bilan bog'lanishda xato!");
        setRangeData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRangeData();
  }, [range, toggle]);

  const applyRange = () => {
    if (!isValidRange(localRange)) {
      alert("Sana oralig'ini to'g'ri kiriting!");
      return;
    }

    setRange(localRange);
  };

  return (
    <div>
      <ContentTop>
        <ul
          className='content-top-left suv-omborlari'
          style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <li>02 Reyka va Uchqurg’on</li>
          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          {toggle === 1 ? (
            <input
              type='month'
              className='form-control form-control-sm'
              value={lmonth}
              onChange={(e) => setLmonth(e.target.value)}
            />
          ) : (
            <>
              <span className='text-muted small mr-2'>Dan</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.from}
                onChange={(e) =>
                  setLocalRange({ ...localRange, from: e.target.value })
                }
              />
              &nbsp;&nbsp;
              <span className='text-muted small mr-2'>Gacha</span>
              <input
                type='date'
                className='form-control form-control-sm'
                value={localRange.to}
                onChange={(e) =>
                  setLocalRange({ ...localRange, to: e.target.value })
                }
              />
              &nbsp;&nbsp;&nbsp;
              <button
                className='btn btn-outline-primary btn-sm'
                onClick={applyRange}>
                Ok
              </button>
            </>
          )}
        </ul>
      </ContentTop>

      <div className='tabs-content table-box extra-tab-css'>
        <div className='tabs-content-item active'>
          <div className='table-box-con'>
            <Routes>
              <Route
                path='/'
                element={
                  <Table5
                    isRange={toggle === 2}
                    loading={loading}
                    month={toggle === 1 ? month : range.from.slice(0, 7)}
                    data={toggle === 1 ? data : rangeData}
                    setDate={setDate}
                  />
                }
              />
              <Route
                path='/add'
                element={<Add date={date} setDate={setDate} />}
              />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reka02;
